export const ParseDate = (dateString: string): string | null => {

  if (!dateString) {
    return '01/1900/01';
  }

  let parts: string[];
  let separator = '/';

  // Check the separator in the date string
  if (dateString.includes('-')) {
    separator = '-';
  }

  // Split the date string based on the separator
  parts = dateString.split(separator);
  const firstPart = parseInt(parts[0], 10);
  const secondPart = parseInt(parts[1], 10);
  const thirdPart = parseInt(parts[2], 10);

  const cYear = firstPart.toString().length > 3 ? firstPart : thirdPart;

  const cMonth = firstPart.toString().length > 3
    ? (secondPart <= 12 ? secondPart : (secondPart > thirdPart ? thirdPart : secondPart))
    : (firstPart <= 12 ? firstPart : (firstPart > secondPart ? secondPart : firstPart));

  const cDay = firstPart.toString().length > 3
    ? (secondPart <= 12 ? thirdPart : (secondPart > thirdPart ? secondPart : thirdPart))
    : (firstPart <= 12 ? secondPart : (firstPart > secondPart ? firstPart : secondPart));

  return `${cYear}-${cMonth < 10 ? '0' + cMonth : cMonth}-${cDay < 10 ? '0' + cDay : cDay}`;

};

export type LocalInputType = "date" | "datetime";

export const formatToLocalInput = (
  value: string | Date | null | undefined,
  type: LocalInputType = "date"
): string => {
  if (!value) return "";

  const date = value instanceof Date ? value : new Date(value);

  if (isNaN(date.getTime())) return "";

  // adjust for timezone so it matches HTML input fields
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

  const iso = local.toISOString();

  return type === "datetime"
    ? iso.slice(0, 16) // YYYY-MM-DDTHH:mm
    : iso.slice(0, 10); // YYYY-MM-DD
};

export const formatDateTime = (
  value: string | Date | null | undefined
): string => {
  if (!value) return "";

  const date = value instanceof Date ? value : new Date(value);

  if (isNaN(date.getTime())) return "";

  const formatted = date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return formatted.replace(",", "");
};